// src/components/HeroSection.jsx
import { Link } from "react-router-dom";
import { FaDiscord, FaChevronDown } from "react-icons/fa";
import Logo from "../assets/logo/pvalorlogo.png";

function HeroSection() {
  return (
    <section className="relative min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        {/* Animated gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-red-900/20 via-black to-black"></div>

        {/* Grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                              linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
            backgroundSize: '50px 50px'
          }}
        ></div>

        {/* Glowing orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600/30 blur-[128px] rounded-full"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-red-800/20 blur-[100px] rounded-full"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {/* Logo */}
        <div className="mb-8" data-aos="fade-down" data-aos-delay="100">
          <img
            src={Logo}
            alt="Prime Valor Logo"
            className="mx-auto h-24 md:h-32 w-auto drop-shadow-2xl"
          />
        </div>

        {/* Main Heading */}
        <h1
          className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black uppercase tracking-tight mb-6"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <span className="text-white">Prime</span>{" "}
          <span className="text-red-600">Valor</span>
        </h1>

        {/* Tagline */}
        <p
          className="text-xl md:text-2xl text-gray-300 mb-4 max-w-2xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          Elevating Caribbean Gaming
        </p>
        <p
          className="text-lg text-gray-500 mb-12"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          Competitive Gaming | Content Creation | Community
        </p>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <Link
            to="/roster"
            className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wide rounded transition-all duration-300 hover:scale-105 shadow-lg shadow-red-600/25"
          >
            Meet the Team
          </Link>
          <a
            href="https://discord.gg/SGXXCMpCxf"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-transparent border-2 border-white/20 hover:border-white/40 text-white font-bold uppercase tracking-wide rounded transition-all duration-300 hover:bg-white/5 flex items-center gap-2"
          >
            <FaDiscord className="text-xl" />
            Join Discord
          </a>
        </div>

        {/* Stats */}
        <div
          className="mt-20 grid grid-cols-3 gap-8 max-w-2xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          <div>
            <div className="text-3xl md:text-4xl font-black text-red-600">15+</div>
            <div className="text-sm text-gray-500 uppercase tracking-wide">Players</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-black text-red-600">4+</div>
            <div className="text-sm text-gray-500 uppercase tracking-wide">Divisions</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-black text-red-600">5+</div>
            <div className="text-sm text-gray-500 uppercase tracking-wide">Countries</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <FaChevronDown className="text-white/30 text-2xl" />
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
    </section>
  );
}

export default HeroSection;
